import React from "react"

function IconArrowsMerge({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="arrows-merge"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-arrows-merge"
      {...props}
    >
      <path
        d="M6.007 13.101c.298.325.614.631.944.922l-.155.237a10.648 10.648 0 0 0-1.011 2.108l-.059.172.213-.14a11.118 11.118 0 0 1 2.578-1.19c.372.243.758.47 1.157.681l.477.24c-2.605.564-4.171 1.672-5.106 2.717l-.207.243-.186.24-.085.117-.155.23-.07.112-.126.216-.11.205-.093.193-.112.262-.058.153-.08.248-.054.212.004-.419c.072-3.39 1.002-5.9 2.294-7.759zM3.71 2.812l.03.129.09.293.092.242.08.185.095.201.114.216.064.112.143.233.165.242.09.124.199.252c1.156 1.4 3.421 2.987 7.802 3.256l.417.022V5.537l.008-.075a.327.327 0 0 1 .473-.214l.066.047 7.284 6.616.05.057c.07.102.076.236.016.344l-.044.061-7.306 6.64-.061.043a.327.327 0 0 1-.476-.206l-.01-.08v-2.914l-.147-.042-.31-.095-.327-.108-.341-.123-.356-.138-.367-.154-.472-.216-.096-.047-.387-.198-.384-.212C7.072 12.898 3.988 9.737 3.727 3.65l-.014-.42-.003-.418zm2.174 4.844-.163-.11.012.035c.892 2.646 2.58 4.535 4.839 5.817l.311.171.525.264.342.156.334.141.323.126.312.112.297.1.38.114 1.005.282-.001 1.686 4.84-4.399-4.84-4.396v1.928l-1.363-.056c-3.018-.124-5.38-.825-7.153-1.971z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconArrowsMerge
